import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import { ImageGallery } from '../../../../Utils/Constants'
import MyGallery from './MyGallery'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'

const GalleryGridContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardHeaderCommon title={ImageGallery} />
            <CardBody className="gallery my-gallery">
              <Row>
                <MyGallery />
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default GalleryGridContainer